import React from 'react';

export default function EditVehicleModal({
  isOpen,
  onClose,
  vin,
  onVinChange,
  category,
  onCategoryChange,
  range,          // текст диапазона из выбранной категории
  taxAmount,
  logging,
  onLoggingChange,
  isAgricultural = false,
  onAgriculturalChange,
  weightCategories,
  onSave
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md border border-gray-300 px-6 py-4">
        <h2 className="text-lg font-bold mb-3 text-[#0F2C5E]">Edit Vehicle</h2>

        {/* VIN */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">VIN</label>
          <input
            type="text"
            value={vin}
            onChange={e => onVinChange(e.target.value.toUpperCase())}
            maxLength={17}
            className="w-full p-2 border border-gray-300 focus:outline-none"
          />
        </div>

        {/* Weight Category */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">Weight Category</label>
          <select
            value={category}
            onChange={onCategoryChange}
            className="w-full p-2 border border-gray-300 focus:outline-none"
          >
            <option value="">-- Select Weight Category --</option>
            {weightCategories.map(cat => (
              <option key={cat.letter} value={cat.letter}>
                {cat.letter === 'W'
                  ? 'Category W: Tax Suspended Vehicle — $0'
                  : `Category ${cat.letter}: ${cat.range} lbs — $${cat.tax}`}
              </option>
            ))}
          </select>
        </div>

        {/* Suspension mileage limit (category W only) */}
        {category === 'W' && (
          <div className="mb-3 p-3 bg-blue-50 border border-blue-200 text-sm">
            <label className="flex items-center gap-2 mb-1">
              <input
                type="radio"
                name="edit-suspension-limit"
                checked={!isAgricultural}
                onChange={() => onAgriculturalChange && onAgriculturalChange(false)}
              />
              <span>Standard — 5,000 miles or less</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="edit-suspension-limit"
                checked={isAgricultural}
                onChange={() => onAgriculturalChange && onAgriculturalChange(true)}
              />
              <span>Agricultural — 7,500 miles or less</span>
            </label>
          </div>
        )}

        {/* Gross Weight (диапазон) */}
        <div className="mb-3">
          <label className="block mb-1 font-medium text-sm">Gross Weight</label>
          <input
            type="text"
            value={range}
            readOnly
            className="w-full p-2 border border-gray-300 bg-gray-100 focus:outline-none"
          />
        </div>

        {/* Tax Amount */}
        <div className="mb-4">
          <label className="block mb-1 font-medium text-sm">Tax Amount</label>
          <input
            type="text"
            value={`$${taxAmount}`}
            readOnly
            className="w-full p-2 border border-gray-300 bg-gray-100 focus:outline-none"
          />
        </div>

        {/* Logging */}
        <div className="mb-4">
          <label className="block mb-1 font-medium text-sm">Logging (if applicable)</label>
          <input
            type="text"
            value="No"
            readOnly
            className="w-full p-2 border border-gray-300 bg-gray-100 cursor-not-allowed focus:outline-none text-sm"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-sm hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            className="px-4 py-2 bg-[#0F2C5E] text-white text-sm hover:bg-[#0F2C5E]/80 transition"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
